import { render, staticRenderFns } from "./UrlsCard.vue?vue&type=template&id=0742dc4d&"
import script from "./UrlsCard.vue?vue&type=script&lang=js&"
export * from "./UrlsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports